export const loaderMutations = {
    changeLoader(store, payload){
        store.loading = payload
    },
    changeLoaderB(store, payload){
        store.bLoading = payload
    },
    changeTableLoader(store, payload) {
        store.table = payload
    },
    changeFinalizedTableLoader(store, payload) {
        store.finalizedTable = payload
    },
    changeBranchesLoader(store, payload) {
        store.branches = payload
    },
    changeLoginLoader(store, payload) {
        store.loginLoader = payload
    },
    changeSealChangesLoader(store, payload) {
        store.sealChangesTable = payload
    }
}

export const sidebarMutations = {
    changeDrawerState(store, payload) {
        store.drawer = payload
    }
}

export const appBarMutations = {
    setTitle(store, payload) {
        store.title = payload
    }
}

export const flagMutations = {
    setFileNotFoundDialog(store, payload) {
        store.fileNotFoundDialog = payload
    }
}
